import React, {ReactNode} from 'react';
import './ListViewItem.scss';
import Icon, {IconSizes} from '../../icon/Icon';
import ListViewItemSecondaryButton, {ItemSecondaryButtonProps} from './ListViewItemSecondaryButton';
import ListViewItemPrimaryButton, {ListViewItemPrimaryButtonProps} from './ListViewItemPrimaryButton';

/**
 * Properties of the SplitItem component.
 */
export interface ListViewSplitItemProps {
  primaryButton: ListViewItemPrimaryButtonProps
  secondaryButton: ItemSecondaryButtonProps,
  confirmationMessage?: string;
}

const ListViewSplitItem: React.FC<ListViewSplitItemProps> = (props) => {

  function renderConfirmationMessage(): ReactNode {
    return props.confirmationMessage && (
        <div className="listview-item__copy-confirmation">
          <Icon category="fa-circle-check"
                size={IconSizes.SMALL}/>
          {props.confirmationMessage}
        </div>
    );
  }

  return <li className="listview-item">
    <ListViewItemPrimaryButton {...props.primaryButton} />
    <ListViewItemSecondaryButton {...props.secondaryButton}/>
    {renderConfirmationMessage()}
  </li>;
};

export default ListViewSplitItem;
